import script from "./ParticleScroll.vue?vue&type=script&setup=true&lang=ts"
export * from "./ParticleScroll.vue?vue&type=script&setup=true&lang=ts"

import "./ParticleScroll.vue?vue&type=style&index=0&id=0820480c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0820480c"]])

export default __exports__